import {
  showSuccess,
  showError,
  FGListen,
  FieldGroup,
  FGTextInput,
  FGCheckboxInput,
  FGSelectInput,
  FGMultiSuggestInput,
} from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";
import { ERoutes } from "../../../../ERoutes";
import { PersonApi } from "../../../../api";
import { SmallFormGenerator, SharepointButton } from "../../../../components";
import { useApiService, useTl, useCrudApi } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { VeterinaryClinicsList } from "./vetInformation/VeterinaryClinicsList";
import * as Yup from "yup";
import { useReferential } from "../../../../hooks/useReferential";

export interface IPersonCommissionerPageProps {
  personId: number;
}

export const PersonCommissionerPage: React.FunctionComponent<IPersonCommissionerPageProps> = ({ personId }) => {
  const history = useHistory();
  const api = useApiService(PersonApi);
  const { t } = useTl();
  const { state } = useParams<{ state: string }>();
  const [allLanguagesReferential, allLanguagesReferentialLoading] = useReferential(
    (a) => a.getAllLanguages(),
    true,
    []
  );

  const [commissionerExperience, commissionerExperienceLoading] = useReferential(
    (a) => a.getCommissionerExperience(),
    false,
    []
  );

  const { data, saveItem, saving, loading } = useCrudApi(
    {
      getApiFn: () => api.getPersonCommissioner(personId),
      saveApiFn: (d) => api.saveCommissioner(d),
      deleteApiFn: (d) => {},
    },
    [personId]
  );

  const validationSchema = React.useMemo(() => {
    return Yup.object().shape({
      commissionerExperience: Yup.string().nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);

  return (
    <>
      <SmallFormGenerator
        onSubmit={saveItem}
        initialValues={data}
        editMode={state === "edit"}
        minLabelWidth={150}
        saving={saving}
        loading={loading}
        validationSchema={validationSchema}
      >
        <FieldGroup
          fieldsetProps={{
            title: t(ETLCodes.Commissioner),
          }}
        >
          <FGSelectInput
            name="commissionerExperience"
            label={t(ETLCodes.commissionerExperience)}
            items={commissionerExperience}
            loading={commissionerExperienceLoading}
            displayField="label"
            valueField="value"
          />
          <FGMultiSuggestInput
            label={t(ETLCodes.SpokenLanguages)}
            items={allLanguagesReferential}
            loading={allLanguagesReferentialLoading}
            displayField={"label"}
            valueField={"value"}
            isFilterable={true}
            name="spokenLanguageIds"
          />
        </FieldGroup>
      </SmallFormGenerator>
    </>
  );
};
